import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import LoginPage from './pages/LoginPage'
import DashboardLayout from './components/Layout/DashboardLayout'
import VehicleListPage from './pages/VehicleListPage'
import LeaseTransferPage from './pages/LeaseTransferPage'
import VehicleManagerPage from './pages/VehicleManagerPage'
import AccountantPage from './pages/AccountantPage'
import CashierPage from './pages/CashierPage'
import BossPage from './pages/BossPage'
import PartsPage from './pages/PartsPage'
import RouteGuard from './components/Security/RouteGuard'
import { useAuthStore } from './stores/authStore'

const { Content } = Layout

function App() {
  const { user, getDefaultRoute } = useAuthStore()

  return (
    <Router basename={import.meta.env.BASE_URL}>
      <Routes>
        {/* 登录页面 */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* 需要登录的页面 */}
        <Route path="/" element={
          user ? (
            <DashboardLayout>
              <Navigate to={getDefaultRoute()} replace />
            </DashboardLayout>
          ) : (
            <Navigate to="/login" replace />
          )
        } />
        
        {/* 受保护的路由 - 带角色权限验证 */}
        <Route path="/vehicles" element={
          <RouteGuard>
            <DashboardLayout>
              <VehicleListPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/vehicles/:id/lease-transfer" element={
          <RouteGuard>
            <DashboardLayout>
              <LeaseTransferPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/vehicle-manager" element={
          <RouteGuard>
            <DashboardLayout>
              <VehicleManagerPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/accountant" element={
          <RouteGuard>
            <DashboardLayout>
              <AccountantPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/cashier" element={
          <RouteGuard>
            <DashboardLayout>
              <CashierPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/parts" element={
          <RouteGuard>
            <DashboardLayout>
              <PartsPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        <Route path="/boss" element={
          <RouteGuard>
            <DashboardLayout>
              <BossPage />
            </DashboardLayout>
          </RouteGuard>
        } />
        
        {/* 其他路由重定向到根路径 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default App
